export default __webpack_public_path__ + "static/media/Crossbow of the Haunter in the Dark.1b2a8c9d.jpg";